
import { Options, Vue, prop } from "vue-class-component";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { PrintReceiptController } from "@/app/ui/controllers/PrintReceiptController";
import SendInvoiceReceiverRows from "./SendInvoiceReceiverRows.vue";
import {
  InvoiceDataInterface,
  Receiver,
  RecipientTag
} from "@/domain/entities/PrintReceipt";
import { getPhoneDisplayCode } from '@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber';

class Props {
  show = prop<boolean>({
    type: Boolean,
    default: false
  });
  invoiceData = prop<InvoiceDataInterface>({
    type: InvoiceDataInterface,
    default: new InvoiceDataInterface()
  });
  mode = prop<string>({
    type: String,
    default: "send"
  });
}

@Options({
  components: {
    SendInvoiceReceiverRows
  }
})

export default class ModalSendInvoicePicker extends Vue.with(Props) {
  props: any = this.$props;

  // Modal state
  showSuccessModal = false;
  // successData: any = null;
  isLoadingSend = false;
  file = {} as File;

  // Receivers state from child component
  receiversData: any = {
    receivers: [],
    validReceivers: [],
    isValid: false
  };

  // Dropdown options
  viaOptions = [
    { name: "Email", value: "email" },
    { name: "WhatsApp", value: "whatsapp" }
  ];

  formatOptions = [
    { name: "PDF (A4)", value: "pdf_a4" },
    { name: "PNG (A4)", value: "png_a4" },
    { name: "PDF (Ukuran Struk)", value: "pdf_struk" }
  ];

  // Computed
  get modalTitle(): string {
    return this.$t("tagihan.activity.sendInvoice");
  }

  get isDisabledSubmit() {
    return !this.receiversData.isValid;
  }

  get successData() {
    return PrintReceiptController.invoiceSuccessData;
  }

  // Methods
  onReceiversUpdate(data: any) {
    this.receiversData = data;
  }

  onCloseModal() {
    // this.$emit("update:show", false);
    this.$emit("close");
  }

  async onSubmit() {
    const validReceivers = this.receiversData.validReceivers;

    if (validReceivers.length === 0) {
      return;
    }

    // Mode emit: just emit data back to parent
    if (this.mode === "emit") {
      const tags = validReceivers.map((r: Receiver) => {
        return new RecipientTag({
          type: r.via,
          contact: r.value,
          format: r.format
        });
      });
      this.$emit("submit", tags);
      this.onCloseModal();
      return;
    }
  }

  formatPhone62(phone: string): string {
    let cleaned = phone.replace(/\D/g, "");
    const prefix = getPhoneDisplayCode(
      AccountController.accountData?.countryCode
    ).replace("+", "");
    if (cleaned.startsWith("0")) {
      cleaned = prefix + cleaned.substring(1);
    }
    if (!cleaned.startsWith(prefix)) {
      cleaned = prefix + cleaned;
    }
    return cleaned;
  }

  onCloseSuccessModal() {
    this.showSuccessModal = false;
    this.onCloseModal();
    // Emit success event to parent if needed
    this.$emit("success", this.successData);
  }
}
